export const statusPicking = {
  toArrive: 'EN PROCESO',
  toLocate: 'EN ALMACEN SIN UBICAR',
  warehouse: 'EN ALMACEN UBICADO',
  delivered: 'ENTREGADO TOTALMENTE',
  deliveredPending: 'ENTREGADO PARCIALMENTE',
  canceled: 'CANCELADO',
  returned: 'EN DEVOLUCION',
  returnedSeller: 'DEVOLUCION A SELLER'
};
